import { apiGet, apiPost } from '../_common';

export const availablePlans = [
  { name: "Plano Mensal - R$ 199,90", planId: "br.com.magenta.vindi.basic.monthly.19990" },
  { name: "Plano Semestral - 6x R$ 189,90", planId: "br.com.magenta.vindi.basic.biannually.113940" },
  { name: "Plano Anual - 12x R$ 179,90", planId: "br.com.magenta.vindi.basic.annually.215880" },

  { name: "Plano Semestral com cobrança mensal - 6x R$ 189,90", planId: "br.com.magenta.vindi.basic.biannually.113940.fallback.monthly.18990" },
  { name: "Plano Anual com cobrança mensal - 12x R$ 179,90", planId: "br.com.magenta.vindi.basic.annually.215880.fallback.monthly.17990" },


  { name: "Plano Semestral - sem renovação automática - 6x R$ 205,90", planId: "br.com.magenta.vindi.basic.biannually.no-renewal.123540" },
  { name: "Plano Anual - sem renovação automática - 12x R$ 202,90", planId: "br.com.magenta.vindi.basic.annually.no-renewal.243480" },

  { name: "Plano Semestral com cobrança mensal - sem renovação automática - 6x R$ 205,90", planId: "br.com.magenta.vindi.basic.biannually.no-renewal.123540.fallback.monthly.20590" },
  { name: "Plano Anual com cobrança mensal - sem renovação automática - 12x R$ 202,90", planId: "br.com.magenta.vindi.basic.annually.no-renewal.243480.fallback.monthly.20290" },
]

export const oldMigrationPlans = [
  { name: "Plano Mensal - R$ 169,90", planId: "br.com.magenta.vindi.basic.monthly.16990" },
  { name: "Plano Semestral - 6x R$ 159,90", planId: "br.com.magenta.vindi.basic.biannually.95940" },
  { name: "Plano Anual - 12x R$ 149,90", planId: "br.com.magenta.vindi.basic.annually.179880" },

  { name: "Plano Semestral com cobrança mensal - 6x R$ 159,90", planId: "br.com.magenta.vindi.basic.biannually.95940.fallback.monthly.15990" },
  { name: "Plano Anual com cobrança mensal - 12x R$ 149,90", planId: "br.com.magenta.vindi.basic.annually.179880.fallback.monthly.14990" },

  { name: "Plano Semestral - sem renovação automática - 6x R$ 165,90", planId: "br.com.magenta.vindi.basic.biannually.no-renewal.99540" },
  { name: "Plano Anual - sem renovação automática - 12x R$ 162,90", planId: "br.com.magenta.vindi.basic.annually.no-renewal.195480" },

  { name: "Plano Semestral com cobrança mensal - sem renovação automática - 6x R$ 165,90", planId: "br.com.magenta.vindi.basic.biannually.no-renewal.99540.fallback.monthly.16590" },
  { name: "Plano Anual com cobrança mensal - sem renovação automática - 12x R$ 162,90", planId: "br.com.magenta.vindi.basic.annually.no-renewal.195480.fallback.monthly.16290" },
]

export default {
  getSubscriptionById(id) {
    return apiGet(`/magenta/billing/subscription/${id}`).then(result => result.response);
  },
  getDiscounts(id) {
    return apiGet(`/magenta/billing/subscription/${id}/discounts`).then(result => result.response);
  },
  getInvoices(id) {
    return apiGet(`/magenta/billing/subscription/${id}/invoices`).then(result => result.response);
  },
  getCancellationInfo(id) {
    return apiGet(`/magenta/billing/subscription/${id}/cancellation-fee`)
      .then(result => result.response);
  },
  cancel(id, request) {
    return apiPost(`/magenta/billing/subscription/${id}/cancel`, request).then(result => result.response);
  },
  migrate(id, request) {
    return apiPost(`/magenta/billing/subscription/${id}/migrate`, request).then(result => result.response);
  },
  reactivate(id) {
    return apiPost(`/magenta/billing/subscription/${id}/reactivate`).then(result => result.response);
  }
};
